export const OBJECTIVES = [
  { id: "general", label: "General Inventory", desc: "Highlight key features and overall boat value", icon: "Ship" },
  { id: "fishing", label: "Fishing", desc: "Target anglers - rod holders, livewells, range", icon: "Fish" },
  { id: "family", label: "Family / Lifestyle", desc: "Emphasize seating, watersports, weekend fun", icon: "Users" },
  { id: "performance", label: "Performance", desc: "Focus on horsepower, handling, and thrill", icon: "Gauge" },
  { id: "financing", label: "Financing / Payment", desc: "Promote low monthly payments and zero down", icon: "BadgeDollarSign" },
  { id: "event", label: "Boat Show / Event", desc: "Drive traffic to an upcoming dealership event", icon: "CalendarDays" },
  { id: "tradein", label: "Trade-In", desc: "Encourage owners to trade up to a new model", icon: "Repeat" },
];

export const TONES = ["High-end Luxury", "High Energy", "Family Warmth", "Urgent Sale"];

export const CATEGORIES = [
  "Bowrider", "Center Console", "Pontoon", "Bay Boat", "Skiff", "Bass Boat", "Wake & Ski",
  "Jet Boat", "Cruiser", "Yacht", "Sport Fishing", "Cuddy Cabin", "Deck Boat",
];

export const STATUSES = ["In Stock", "On Order", "Sold"];

export const EVENT_TYPES = [
  "Boat Show", "Marine Expo", "Fishing Expo", "Boating Expo", "Yacht / Marine Show",
  "Industry Show / Event", "Dealer Open House", "Demo Day", "Fishing Tournament",
  "Manufacturer Promotion", "Holiday Promotion", "Model Launch", "Other",
];

export const STATUS_STYLES = {
  "In Stock": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "On Order": "bg-blue-50 text-blue-700 border-blue-200",
  "Sold": "bg-red-50 text-red-700 border-red-200",
};

export function money(v) {
  if (v === null || v === undefined || v === "") return "Call for price";
  const n = Number(v);
  if (Number.isNaN(n)) return "Call for price";
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}
